import { SilentErrorBoundary } from './silent-error-boundary';

export function withSilentErrorBoundary<T extends {}>(
  Component: React.ComponentType<T>,
): React.ComponentType<T> {
  return (props) => (
    <SilentErrorBoundary>
      <Component {...props} />
    </SilentErrorBoundary>
  );
}
